module.exports = __webpack_public_path__ + "img/bill_empty_icon.3f68545f.png";